import React from 'react';

const fieldBase =
  'w-full rounded-input border border-border bg-white px-3.5 py-2.5 text-body font-body text-text-primary ' +
  'placeholder:text-text-secondary/50 transition-all duration-150 ' +
  'focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary ' +
  'disabled:bg-background disabled:text-text-secondary/50 disabled:cursor-not-allowed';

const stateStyles = {
  normal: 'border-border',
  error: 'border-danger focus:ring-danger/20 focus:border-danger',
  success: 'border-success focus:ring-success/20 focus:border-success',
};

export function Label({ children, htmlFor, required }) {
  return (
    <label htmlFor={htmlFor} className="mb-1.5 block text-small font-medium text-text-primary font-body">
      {children}
      {required && <span className="text-danger ml-1">*</span>}
    </label>
  );
}

export function HelperText({ error, success, children }) {
  let colorClass = 'text-text-secondary';
  if (error) colorClass = 'text-danger';
  else if (success) colorClass = 'text-success';

  return (
    <p className={`mt-1.5 text-caption font-body ${colorClass}`}>
      {children}
    </p>
  );
}

export function Input({ error, success, className = '', ...props }) {
  const state = error ? 'error' : success ? 'success' : 'normal';
  return <input className={`${fieldBase} ${stateStyles[state]} ${className}`} {...props} />;
}

export function Textarea({ error, success, className = '', rows = 4, ...props }) {
  const state = error ? 'error' : success ? 'success' : 'normal';
  return <textarea rows={rows} className={`${fieldBase} ${stateStyles[state]} ${className}`} {...props} />;
}

export function Select({ error, success, className = '', children, ...props }) {
  const state = error ? 'error' : success ? 'success' : 'normal';
  return (
    <select className={`${fieldBase} ${stateStyles[state]} ${className}`} {...props}>
      {children}
    </select>
  );
}

export function Checkbox({ label, className = '', id, ...props }) {
  return (
    <label htmlFor={id} className="flex items-center gap-2.5 cursor-pointer select-none font-body">
      <input
        id={id}
        type="checkbox"
        className={`h-4.5 w-4.5 rounded-sm border-border text-primary focus:ring-primary/20 ${className}`}
        {...props}
      />
      {label && <span className="text-small text-text-primary font-medium">{label}</span>}
    </label>
  );
}

export function Switch({ checked, onChange, label, id }) {
  return (
    <label htmlFor={id} className="flex items-center gap-3 cursor-pointer select-none font-body">
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange?.(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-150
          focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2
          ${checked ? 'bg-primary' : 'bg-border'}`}
      >
        <span
          className={`inline-block h-4.5 w-4.5 transform rounded-full bg-white transition-transform duration-150
            ${checked ? 'translate-x-5.5' : 'translate-x-1'}`}
        />
      </button>
      {label && <span className="text-small text-text-primary font-medium">{label}</span>}
    </label>
  );
}

export default Input;